import axios from "axios"
import React, { useEffect, useState } from "react"
import DatePicker from "react-datepicker"
import { Col, Input, Label, Row } from "reactstrap"
import Select from "react-select"
import MultipleValueTextInput from "react-multivalue-text-input"
import { useHistory } from "react-router-dom"
import { convertPermission } from "permissionUtils"

const FilterRD5 = ({ filteredValues, setFilteredValues, setAuth }) => {
  // console.log("filteredValues ------------->", filteredValues)

  const history = useHistory()

  const [dateRange, setDateRange] = useState([null, null])
  const [startDate, endDate] = dateRange

  // **************** Permissions ******************************
  const userPermissions = convertPermission(
    JSON.parse(localStorage.getItem("roles"))
  )
  // console.log("userPermissions", userPermissions)

  const convertDate = value => {
    let day = value.getDate() + ""
    day = day.length === 1 ? `0${day}` : day
    let month = value.getMonth() + 1 + ""
    month = month.length === 1 ? `0${month}` : month
    let year = value.getFullYear()
    return `${year}-${month}-${day}` || null
  }

  const statusOptions = [
    { value: "ManagerApproval", label: "ManagerApproval" },
    { value: "ModeratorApproval", label: "ModeratorApproval" },
    { value: "Active", label: "Active" },
    { value: "Inactive", label: "Inactive" },
  ]

  // Des, MS , WI
  const typeOptions = [
    { value: "Des", label: "Design" },
    { value: "MS", label: "Ins- Missing State" },
    { value: "WI", label: "Ins- Work Interruption" },
  ]

  const [users, setUsers] = useState([])
  useEffect(() => {
    const formData = {
      PerToken: localStorage.getItem("token"),
      PerUserID: localStorage.getItem("id"),
      PerRoleID: localStorage.getItem("userRoleID"),
    }
    axios
      .post(process.env.REACT_APP_API_URL + "api/MenuUsersView", formData)
      .then(res => {
        if (res.data.error === true && res.data.message === "Access denied!") {
          setAuth(true)
          setTimeout(() => {
            history.push("/logout")
            setTimeout(() => {
              history.push("/login")
            }, 1000)
          }, 4000)
        }

        let data = Object.entries(res.data)
        data.splice(-1)
        let dataUsers = data.map(user => ({
          value: user[1].UserID,
          label: `${user[1].FirstName} ${user[1].LastName}`,
        }))
        setUsers(dataUsers)
      })
      .catch(error => {
        console.log(error)
      })
  }, [])

  return (
    <>
      <Row className="d-flex justify-content-center">
        <Col md={3}>
          {/* ************************************ Reference No ****************************************** */}
          <div className="search-box me-3 col-12">
            <div className="position-relative mb-2 form-control border-dark py-1 d-flex flex-direction-colmun align-items-center overflow-hidden">
              <i className="bx bx-search-alt search-icon" />
              <MultipleValueTextInput
                onItemAdded={(item, allItems) =>
                  setFilteredValues({
                    ...filteredValues,
                    referenceNo: allItems,
                  })
                }
                onItemDeleted={(item, allItems) =>
                  setFilteredValues({
                    ...filteredValues,
                    referenceNo: allItems,
                  })
                }
                type="number"
                name="referenceNo"
                placeholder="Reference No ..."
                className="border-0 mt-1"
              />
            </div>
          </div>

          {/* ************************************ Policy No ****************************************** */}
          <div className="search-box me-3 col-12">
            <div className="position-relative mb-2 form-control border-dark py-1 d-flex flex-direction-colmun align-items-center overflow-hidden">
              <i className="bx bx-search-alt search-icon" />
              <MultipleValueTextInput
                onItemAdded={(item, allItems) =>
                  setFilteredValues({
                    ...filteredValues,
                    policyNo: allItems,
                  })
                }
                onItemDeleted={(item, allItems) =>
                  setFilteredValues({
                    ...filteredValues,
                    policyNo: allItems,
                  })
                }
                type="number"
                name="policyNo"
                placeholder="Policy No ..."
                className="border-0 mt-1"
              />
            </div>
          </div>

          {/* ************************************ Ticket Code ****************************************** */}
          <div className="search-box me-3 col-12">
            <div className="position-relative mb-2 form-control border-dark py-1 d-flex flex-direction-colmun align-items-center overflow-hidden">
              <i className="bx bx-search-alt search-icon" />
              <MultipleValueTextInput
                onItemAdded={(item, allItems) =>
                  setFilteredValues({
                    ...filteredValues,
                    ticketCode: allItems,
                  })
                }
                onItemDeleted={(item, allItems) =>
                  setFilteredValues({
                    ...filteredValues,
                    ticketCode: allItems,
                  })
                }
                type="text"
                name="ticketCode"
                placeholder="Ticket Code ..."
                className="border-0 mt-1"
              />
            </div>
          </div>
        </Col>

        <Col md={3}>
          {/* ************************************ Request No ****************************************** */}
          <div className="search-box me-3 col-12">
            <div className="position-relative mb-2 form-control border-dark py-1 d-flex flex-direction-colmun align-items-center overflow-hidden">
              <i className="bx bx-search-alt search-icon" />
              <MultipleValueTextInput
                onItemAdded={(item, allItems) =>
                  setFilteredValues({
                    ...filteredValues,
                    requestNo: allItems,
                  })
                }
                onItemDeleted={(item, allItems) =>
                  setFilteredValues({
                    ...filteredValues,
                    requestNo: allItems,
                  })
                }
                type="number"
                name="requestNo"
                placeholder="Request No ..."
                className="border-0 mt-1"
              />
            </div>
          </div>

          {/* ************************************ Areal Decision No ****************************************** */}
          <div className="search-box me-3 col-12">
            <div className="position-relative mb-2 form-control border-dark py-1 d-flex flex-direction-colmun align-items-center overflow-hidden">
              <i className="bx bx-search-alt search-icon" />
              <MultipleValueTextInput
                onItemAdded={(item, allItems) =>
                  setFilteredValues({
                    ...filteredValues,
                    arealDecisionNo: allItems,
                  })
                }
                onItemDeleted={(item, allItems) =>
                  setFilteredValues({
                    ...filteredValues,
                    arealDecisionNo: allItems,
                  })
                }
                type="number"
                name="arealDecisionNo"
                placeholder="Areal Decision No ..."
                className="border-0 mt-1"
              />
            </div>
          </div>

          {/* ************************************ Type ****************************************** */}
          <div className="search-box me-3 col-12 p-0">
            <div className="position-relative mb-3 form-control border-dark py-0">
              <i className="bx bx-search-alt search-icon my-auto" />
              <Select
                isMulti
                options={typeOptions}
                name="type"
                className="react-select-container"
                styles={{
                  control: (baseStyles, state) => ({
                    ...baseStyles,
                    borderColor: state.isFocused
                      ? "transparent"
                      : "transparent",
                    borderColor: state.isSelected
                      ? "transparent"
                      : "transparent",
                    borderWidth: "0px",
                  }),
                }}
                value={filteredValues.type}
                onChange={e => {
                  // console.log(e)
                  setFilteredValues({ ...filteredValues, type: e })
                }}
                classNamePrefix="select"
                placeholder="Type ..."
              />
            </div>
          </div>
        </Col>

        <Col md={3}>
          {/* ************************************ Report ID ****************************************** */}
          <div className="search-box me-3 col-12">
            <div className="position-relative mb-2 form-control border-dark py-1 d-flex flex-direction-colmun align-items-center overflow-hidden">
              <i className="bx bx-search-alt search-icon" />
              <MultipleValueTextInput
                onItemAdded={(item, allItems) =>
                  setFilteredValues({
                    ...filteredValues,
                    RD5ID: allItems,
                  })
                }
                onItemDeleted={(item, allItems) =>
                  setFilteredValues({
                    ...filteredValues,
                    RD5ID: allItems,
                  })
                }
                type="number"
                name="RD5ID"
                placeholder="RD5 ID ..."
                className="border-0 mt-1"
              />
            </div>
          </div>

          {/* ************************************ Status ****************************************** */}
          <div className="search-box me-3 col-12 p-0">
            <div className="position-relative mb-3 form-control border-dark py-0">
              <i className="bx bx-search-alt search-icon my-auto" />
              <Select
                isMulti
                options={statusOptions}
                name="status"
                className="react-select-container"
                styles={{
                  control: (baseStyles, state) => ({
                    ...baseStyles,
                    borderColor: state.isFocused
                      ? "transparent"
                      : "transparent",
                    borderColor: state.isSelected
                      ? "transparent"
                      : "transparent",
                    borderWidth: "0px",
                  }),
                }}
                value={filteredValues.status}
                onChange={e => {
                  // console.log(e)
                  setFilteredValues({ ...filteredValues, status: e })
                }}
                classNamePrefix="select"
                placeholder="Status ..."
              />
            </div>
          </div>
        </Col>

        <Col ms={3}>
          {/* ************************************ Date ****************************************** */}
          <div className="search-box me-3 col-12">
            <div className="position-relative mb-2 d-flex form-control border-dark ">
              <i className="bx bx-search-alt search-icon " />

              <DatePicker
                isClearable
                className="border-0"
                selectsRange={true}
                dateFormat="yyyy/MM/dd"
                startDate={startDate}
                endDate={endDate}
                onChange={update => {
                  setDateRange(update)
                  setFilteredValues({
                    ...filteredValues,
                    startDate: update[0] ? convertDate(update[0]) : null,
                    endDate: update[1] ? convertDate(update[1]) : null,
                  })
                }}
                // withPortal
                placeholderText="Date ..."
              />
            </div>
          </div>

          {/* ************************************ Created By ****************************************** */}
          <div className="search-box me-3 col-12 p-0">
            <div className="position-relative mb-3 form-control border-dark py-0">
              <i className="bx bx-search-alt search-icon my-auto" />
              <Select
                isMulti
                options={users}
                name="creator"
                className="react-select-container"
                styles={{
                  control: (baseStyles, state) => ({
                    ...baseStyles,
                    borderColor: state.isFocused
                      ? "transparent"
                      : "transparent",
                    borderColor: state.isSelected
                      ? "transparent"
                      : "transparent",
                    borderWidth: "0px",
                  }),
                }}
                value={filteredValues.creator}
                onChange={e => {
                  // console.log(e)
                  setFilteredValues({ ...filteredValues, creator: e })
                }}
                classNamePrefix="select"
                placeholder="Created By ..."
                isDisabled={
                  userPermissions.R19.P !== "1" &&
                  userPermissions.R19.P !== "2" &&
                  userPermissions.R19.P !== "3" &&
                  userPermissions.R19.P !== "4" &&
                  userPermissions.R19.G !== "1" &&
                  userPermissions.R3.G !== "1" &&
                  userPermissions.R4.G !== "1"
                }
              />
            </div>
          </div>
        </Col>
      </Row>
    </>
  )
}

export default FilterRD5
